<script>
  import { ConfigStore } from '../../../store/config';
</script>

<div
  class="cs-cb-galaxy"
  style:--cs-galaxy-bg={$ConfigStore.customTheme.launcherGalaxyBgThemeType}
>
  <span class="spark"></span>

  {#if $ConfigStore.customTheme?.launcherLogoHtmlThemeType}
    <div class="cs-launcher-custom-html">
      {@html $ConfigStore.customTheme.launcherLogoHtmlThemeType}
    </div>
  {:else}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="49"
      height="49"
      viewBox="0 0 974 803"
      class="cs-cb-default-logo"
    >
      <defs>
        <filter
          id="filter"
          x="21"
          y="22.969"
          width="487"
          height="650.343"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#555" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-2"
          x="156.875"
          y="29.344"
          width="795.406"
          height="745.656"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#2696c1" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-3"
          x="332"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-4"
          x="496"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
        <filter
          id="filter-5"
          x="659"
          y="318"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feFlood result="flood" flood-color="#fff" />
          <feComposite result="composite" operator="in" in2="SourceGraphic" />
          <feBlend result="blend" in2="SourceGraphic" />
        </filter>
      </defs>
      <g id="Artboard_1" data-name="Artboard 1">
        <g style="fill: #e30000; filter: url(#filter)">
          <path
            id="path-2"
            style:fill={$ConfigStore.customTheme.badgeIconColor}
            class="cls-1"
            d="M508,638l-79,9L210,671S32.511,705.581,21,508V181S24.261-10.169,241,28L507,78l-2,7Z"
            style="stroke: var(--cs-text-button-color); filter: none; fill: inherit; stroke-width: 21px;"
          />
        </g>
        <use
          xlink:href="#path-2"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-2)">
          <path
            id="path"
            style:fill={$ConfigStore.customTheme.badgeBg}
            class="cls-2"
            d="M547,775l36-107s6.918-9.187-11-11-252-28-252-28-162.755-8.812-163-159,0-191,0-191-7.467-135,152-164S761,31,761,31,951.341,0,952,206s0,322,0,322S928.3,696,769,678l-24-2s-16.691-7-38,6S547,775,547,775Z"
            style="stroke: var(--cs-text-button-color); filter: none; fill: inherit; stroke-width: 21px;"
          />
        </g>
        <use
          xlink:href="#path"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-3)">
          <circle
            id="circle-3"
            class="cls-3"
            cx="382.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle-3"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-4)">
          <circle
            id="circle-2"
            class="cls-4"
            cx="546.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle-2"
          style="stroke: #000; filter: none; fill: none"
        />
        <g style="fill: #e30000; filter: url(#filter-5)">
          <circle
            id="circle"
            class="cls-5"
            cx="709.5"
            cy="368.5"
            r="50.5"
            style="stroke: inherit; filter: none; fill: inherit"
          />
        </g>
        <use
          xlink:href="#circle"
          style="stroke: #000; filter: none; fill: none"
        />
      </g>
    </svg>
  {/if}

  <span class="backdrop"></span>

  <span class="text">
    {$ConfigStore.customTheme.textButtonThemeType || 'Shop with AI'}</span
  >

  <svg
    class="sparkle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"
      fill="black"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
      fill="black"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
      fill="black"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</div>

<style lang="scss">
  @use './../../../../scss/components/themes/launcher-theme/launcher-galaxy-theme';
</style>
